// extracted by mini-css-extract-plugin
export default {"element":"SpecialHighschool_element__oGYEe","info":"SpecialHighschool_info__xx95K"};